var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e22079;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,25c0-6.89-2.82-13.16-7.32-17.67C38.18,2.74,31.92,0,25.05,0S11.91,2.74,7.32,7.33C2.82,11.84,0,18.11,0,25c0,6.89,2.82,13.16,7.32,17.67,4.58,4.51,10.76,7.33,17.72,7.33s13.14-2.83,17.64-7.33c4.5-4.5,7.32-10.78,7.32-17.67h0ZM35.54,27.91l-10.32-10.34c-.09-.09-.26-.09-.44,0l-10.32,10.34c-.09.09-.09.35,0,.44l2.29,2.3,8.03-8.13c.18-.09.35-.09.44,0l8.02,8.13,2.29-2.3c.09-.09.09-.35,0-.44h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.c6dd4bfab8cc1b4ff9ca99e06528c969.svg";
export { ForwardRef as ReactComponent };